// -----------------------------------------------------------------------------
// src/Pages/Creator/Start/index.js  – 2025‑06‑30  (Simplified to use User Dashboard)
// -----------------------------------------------------------------------------
import React from "react";
import Dashboard from "../../../Pages/Dashboard/dashboard/dashboard";

/**
 * CreatorStart – Now simply imports and uses the User Dashboard
 * 
 * This eliminates code duplication and ensures consistency between
 * creator and user experiences while maintaining the same routing structure.
 */
const CreatorStart = () => {
  return <Dashboard />;
};

export default CreatorStart;